import { shallowRef } from "vue";
export const activeDataset = shallowRef<{
  id: string;
  name: string;
  capabilities: string[];
  canViewActivity?: boolean;
  write_state: string;
} | null>(null);
export const datasetSection = (tab: string) =>
  ["dashboard", "views", "reports", "rules"].includes(tab)
    ? "reports"
    : ["schema", "sources", "jobs", "activity"].includes(tab)
      ? "setup"
      : "data";
